import { lazy } from 'react';

export default {
    GlassClaim: lazy(() => import('./glass')),

}